import { useEffect, useState } from "react";

/**
 * Trails `value` by `delay` ms.
 *
 * Filter inputs stay controlled on the immediate value so typing never feels laggy,
 * while the expensive derived work (tree filtering, highlighting) runs off the settled
 * term. 200ms is the interval the filter design handoff specifies.
 */
export function useDebouncedValue<T>(value: T, delay = 200): T {
    const [settled, setSettled] = useState(value);

    useEffect(() => {
        const timer = window.setTimeout(() => setSettled(value), delay);
        return () => window.clearTimeout(timer);
    }, [value, delay]);

    return settled;
}

export default useDebouncedValue;
